import React from 'react';
import { Text } from '@consta/uikit/Text';
import { Button } from '@consta/uikit/Button';

// Styles
import cn from 'classnames/bind';
import styles from './styles.styl';
import { TestState } from 'src/redux/features/surveys/testData/types';
import { Informer } from '@consta/uikit/Informer';
import { SurveyStatusEnum } from 'src/utils/enum';

const cx = cn.bind(styles);

export interface ErrorPublishModalProps {
  testData: TestState;
  allListQuestion: number;
  setModalErrorPublish: (item: boolean) => void;
  title: string;
  text: string;
}

export const ErrorPublishModal: React.FC<ErrorPublishModalProps> = ({
  testData,
  allListQuestion,
  setModalErrorPublish,
  title,
  text,
}) => {
  return (
    <Informer
      view="bordered"
      status="alert"
      className={cx('ErrorPublishModal')}
    >
      <Text className={cx('ErrorPublishModal__title')} size="xl">
        {title}
      </Text>
      <Text className={cx('ErrorPublishModal__description')} size="m">
        {text}
      </Text>
      <ul className={cx('ErrorPublishModal__errorMessage')}>
        {!testData.name && (
          <li className={cx('ErrorPublishModal__message')}>
            <Text> Название опроса</Text>
          </li>
        )}
        {(!testData.welcome_page_header ||
          !testData.welcome_page_description) &&
          testData.status === SurveyStatusEnum.DRAFT && (
            <li className={cx('ErrorPublishModal__message')}>
              <Text> Приветственная страница</Text>
            </li>
          )}
        {(!testData.final_page_header || !testData.final_page_description) &&
          testData.status === SurveyStatusEnum.DRAFT && (
            <li className={cx('ErrorPublishModal__message')}>
              <Text> Страница «Спасибо»</Text>
            </li>
          )}
        {allListQuestion < 1 && (
          <li className={cx('ErrorPublishModal__message')}>
            <Text> Создать хотя бы один вопрос</Text>
          </li>
        )}
      </ul>
      <Button
        className={cx('ErrorPublishModal__btn')}
        onClick={() => setModalErrorPublish(false)}
        size="m"
        view="primary"
        label="Спасибо, понятно"
      />
    </Informer>
  );
};
